module.exports = __webpack_public_path__ + "06_long_brown.eee3c6c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/06_long_brown.png
// module id = a6H1
// module chunks = 0